module.exports = __webpack_public_path__ + "img/icon_shopping_pre.525ce8cd.png";